
import { read, utils } from "xlsx";
import { useState, useRef, useEffect, Fragment } from "react";
import { Button, Col, Modal, Row, Table } from "react-bootstrap";
import { addNewExcelTemplate, getExcelTemplates, setErrorDialog } from "../store/api/CommonFunctions";
import { ArrowLeft, BookmarkPlusFill, BookmarksFill, CaretDownSquare, CheckLg, DashCircle, FileEarmarkExcel, List, StarFill, X } from "react-bootstrap-icons";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import ModalSearchStorage from "../Components/Modals/ModalSearchStorage";

const ModalImportFromExcel = (props) => {
    const { show, setShow, pageFields, submitData, formName } = props;
    const dispatch = useDispatch();
    const chkUpdate = useRef();
    const [saveCardData, setsaveCardData] = useState({});
    const workbook = useRef({});
    const jsonData = useRef([]);
    const divExlCols = useRef();
    const txtTempName = useRef();
    const divPageFields = useRef();
    const selectedForMap = useRef({});
    const [templates, setTemplates] = useState([]);
    const [mappedResult, setMapping] = useState([]);
    const [sheetNames, setSheetNames] = useState([]);
    const [showDivAddtemp, setDivAddTemp] = useState(false);
    const [showTempaltes, setShowTemplates] = useState(false);
    const [exlSheetHeaders, setExlSheetHeaders] = useState([]);
    const [popStorage, setPopStorage] = useState({ show: false });
    const close = () => {
        setExlSheetHeaders([]);
        setSheetNames([]);
        selectedForMap.current = {};
        workbook.current = {};
        jsonData.current = {};
        setMapping([]);
        setShow(false);
    }
    const getUploadedFile = (e) => {
        const f = e.currentTarget.files[0];
        f.arrayBuffer().then(data => {
            workbook.current = read(data);
            setSheetNames(workbook.current.SheetNames);
        });
    }
    const setcurrSheet = (sheetName) => {
        if (sheetName === '') {
            setExlSheetHeaders([]);
            return;
        }
        const worksheet = workbook.current.Sheets[sheetName];
        jsonData.current = utils.sheet_to_json(worksheet, { defval: null });
        if (!jsonData.current || jsonData.current.length === 0) {
            setExlSheetHeaders([]);
        }
        else {
            setExlSheetHeaders(Object.keys(jsonData.current[0]));
        }
    }
    const selectExlCol = (el, col) => {
        selectedForMap.current.ExcelCol = col;
        const elArray = divExlCols.current.querySelectorAll(".clickedRow");
        elArray.forEach(el => el.classList.remove("clickedRow"));
        el.classList.add('clickedRow');
    }
    const selectPageField = (el, field) => {
        selectedForMap.current.Field = field;
        const elArray = divPageFields.current.querySelectorAll(".clickedRow");
        elArray.forEach(el => el.classList.remove("clickedRow"));
        el.classList.add('clickedRow');
    }
    const add2Mapping = () => {
        if (!selectedForMap.current || !selectedForMap.current.ExcelCol || !selectedForMap.current.Field) {
            return;
        }
        const elArray = divExlCols.current.querySelectorAll(".clickedRow");
        elArray.forEach(el => el.classList.remove("clickedRow"));
        const elArray2 = divPageFields.current.querySelectorAll(".clickedRow");
        elArray2.forEach(el => el.classList.remove("clickedRow"));
        const selected = { ...selectedForMap.current };
        selectedForMap.current = {};
        setMapping([...mappedResult, selected]);
    }
    const mapResultClick = (el, result) => {
        // const elArray = divMapResult.current.querySelectorAll(".clickedRow");
        // elArray.forEach(el => el.classList.remove("clickedRow"));
        // el.classList.add('clickedRow');
        const mp = mappedResult.filter(m => m.Field.DatabaseName !== result.DatabaseName);
        setMapping(mp);
    }
    const getSameCols = () => {
        if (!exlSheetHeaders || !pageFields || pageFields.length === 0) {
            return;
        }
        const arr = [];
        for (let i = 0; i < exlSheetHeaders.length; i++) {
            const found = pageFields.find(p => p.DisplayName.includes(exlSheetHeaders[i]) || exlSheetHeaders[i].includes(p.DisplayName));
            if (found) {
                const selected = { Field: found, ExcelCol: exlSheetHeaders[i] };
                arr.push(selected);
            }
        }
        setMapping(arr);
    }
    const createObjectArray = () => {
        if (!jsonData.current || jsonData.current.length === 0) {
            return;
        }
        let array = [];
        jsonData.current.forEach((data) => {
            const obj = {};
            for (let i = 0; i < mappedResult.length; i++) {
                obj[mappedResult[i].Field.DatabaseName] = data[mappedResult[i].ExcelCol];
            }
            array.push(obj);
        });
        submitData(array, chkUpdate.current?.checked, saveCardData);
        //console.log(array);
    }
    const addNewTemplate = () => {
        if (txtTempName.current.value === '') {
            setErrorDialog(dispatch, "نام قالب مشخص نشده است", "قالب جدید");
            return;
        }
        if (!mappedResult || mappedResult.length === 0) {
            setErrorDialog(dispatch, "لیست آیتم ها خالی است", "قالب جدید");
            return;
        }
        const array = [];
        mappedResult.forEach((item) => {
            const template = {};
            template.FormName = formName;
            template.TempName = txtTempName.current.value;
            template.ExclColumn = item.ExcelCol;
            template.GridColumn = item.Field.DatabaseName;
            template.GridDisplay = item.ExcelCol + "-->" + item.Field.DisplayName;
            array.push(template);
        });
        const onSuccess = () => {
            setErrorDialog(dispatch, "قالب با موفقیت ایجاد شد", "قالب جدید")
            setDivAddTemp(false);
            getTemplateList();
        }
        dispatch(addNewExcelTemplate(array, onSuccess));
    }
    const templateRowClick = (template) => {
        if (exlSheetHeaders.length === 0) {
            setErrorDialog(dispatch, "لیست ستونهای Excel خالی است. فایل Excel را انتخاب کرده و برگه مورد نظر را انتخاب کنید", "انتخاب قالب Excel");
            return;
        }
        setShowTemplates(false);
        setMapping(template.Details.filter(t => exlSheetHeaders.find(e => e === t.ExcelCol)));
    }
    const getTemplateList = () => {
        const onSuccess = (templates) => {
            const array = [];
            templates.forEach(t => {
                let itm = array.find(a => a.Code === t.Code);
                if (!itm) {

                    itm = {};
                    itm.TempName = t.TempName;
                    itm.Code = t.Code;
                    array.push(itm);
                }
                if (!itm.Details) {
                    itm.Details = [];
                }
                const dtl = { Field: { DatabaseName: t.GridColumn, DisplayName: t.GridDisplay.split("-->")[1] }, ExcelCol: t.ExclColumn };
                itm.Details.push(dtl);

            })
            setTemplates(array);
        }
        getExcelTemplates(formName, onSuccess);
    }
    function showAddTemplates() {
        if (mappedResult?.length > 0 && Array.isArray(mappedResult)) {
            setDivAddTemp(true);
        }
    }
    function showModalStorage(e) {
        if (e.key) {
            if (e.key === "Tab" || e.altKey || e.ctrlKey || e.shiftKey || !(e.key.match(/[a-z,آ-ی,' ']/i))) {
                return;
            }
            e.preventDefault();
        }
        const onSelectStorage = (data) => {
            setsaveCardData({ ...saveCardData, StorageID: data?.StorageID, StorageName: data?.StorageName });
        }
        setPopStorage({
            show: true,
            isStaffStorage: false,
            setStorageData: onSelectStorage
        })
    }
    useEffect(() => {
        if (show) {
            getTemplateList();
        }
        return () => {
            setsaveCardData({});
            setMapping([]);
            setExlSheetHeaders([]);
        }
    }, [show]);
    return (
        <Modal size="lg" show={show} style={{ direction: "rtl" }} onHide={() => { }}>
            <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />
            <Modal.Header className="headerStyle">
                <span><FileEarmarkExcel size={18} /> دریافت فایل از اکسل</span>
                <FontAwesomeIcon icon={faTimes} onClick={close} size="lg" />
            </Modal.Header>
            <Modal.Body style={{ paddingTop: 0 }} className="bodyStyle">
                <div className="row" style={{ margin: "0" }}>
                    <div className="form-group col-md-6">
                        <input className="form-control" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={e => getUploadedFile(e)} />
                    </div>
                    <div className="form-group col-md-6">
                        <select className="form-control" onChange={e => setcurrSheet(e.target.value)}>
                            <option value="">برگه را انتخاب کنید</option>
                            {sheetNames &&
                                sheetNames.map((item, i) =>
                                    <option key={i} value={item}>{item}</option>
                                )
                            }
                        </select>
                    </div>

                    <div className="col-md-6 form-group">
                        <label style={{ fontWeight: "bold", color: "#3d33e7e3" }}>ستونهای فایل اکسل</label>
                        <div ref={divExlCols} className="scThin" style={{ border: "1px solid", borderRadius: "3px", backgroundColor: "#10b4a5", padding: "5px 2px 5px 5px", height: "200px", margin: "auto", overflowY: "auto" }}>
                            {exlSheetHeaders && Array.isArray(exlSheetHeaders) && exlSheetHeaders.filter(ex => !mappedResult.find(m => m.ExcelCol === ex)).map((item, i) =>
                                <div key={i} className="resultTableRow" style={{ padding: "1px 5px 1px 1px" }} onClick={e => selectExlCol(e.currentTarget, item)}>
                                    {item}
                                </div>)}
                        </div>
                    </div>
                    <div className="col-md-6 form-group">
                        <label style={{ fontWeight: "bold", color: "#3d33e7e3" }}>فیلدهای صفحه</label>
                        <div ref={divPageFields} className="scThin" style={{ border: "1px solid", borderRadius: "3px", backgroundColor: "#de96a0", padding: "5px 2px 5px 5px", height: "200px", margin: "auto", overflowY: "auto" }}>
                            {pageFields && Array.isArray(pageFields) && pageFields.filter(p => !mappedResult.find(m => m.Field?.DatabaseName === p.DatabaseName)).map((item, i) =>
                                <div key={i} className="resultTableRow" style={{ padding: "1px 5px 1px 1px" }} onClick={e => selectPageField(e.currentTarget, item)} >
                                    {item.DisplayName}
                                </div>)}
                        </div>
                    </div>
                </div>
                <div className="row mt-1" style={{ margin: "0", backgroundColor: "#f4eaea", margin: "10px", borderRadius: "3px", border: "1px solid #f4eaea" }}>
                    <div className="col-md-2">
                        <label className="tooltipBtn" style={{ padding: "2px" }} data-tooltip="افزودن به لیست">
                            <CaretDownSquare size={25} color="green" className="rowBtn" style={{ cursor: "pointer" }} onClick={add2Mapping} />
                            
                        </label>
                        <label className="tooltipBtn" data-tooltip="افزودن ستونهای مشابه">
                            <StarFill size={21} color="#0080ff" className="rowBtn" style={{ cursor: "pointer" }} onClick={getSameCols} />
                        </label>
                        <label className="tooltipBtn" data-tooltip="انتخاب قالب">
                            <BookmarksFill size={20} color="#e7026e" className="rowBtn" style={{ cursor: "pointer" }} onClick={() => setShowTemplates(!showTempaltes)} />
                        </label>
                    </div>
                </div>
                {showTempaltes &&
                    <Row style={{ margin: 0 }}>
                        <Col md={4}>
                            <Table className="designedTable" style={{ "--rowColor": "#dedffa91" }} >
                                <thead style={{ backgroundColor: "#a3a9df" }}>
                                    <tr><th>نام قالب اکسل</th></tr>
                                </thead>
                                <tbody>
                                    {templates && Array.isArray(templates) && templates.map((item, i) =>
                                        <tr key={i} onClick={() => templateRowClick(item)}>
                                            <td>{item.TempName}</td>
                                        </tr>)}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                }
                {!showTempaltes &&
                    <div className="scThin" style={{ margin: "0", fontSize: "12px", backgroundColor: "rgb(235 234 244)", margin: "10px", borderRadius: "3px", border: "rgb(235 234 244)", height: "150px", overflowY: "auto", padding: "10px" }}>
                        <label className="tooltipBtn" style={{ position: "absolute", right: "17px", cursor: "pointer" }} data-tooltip="افزودن قالب">
                            <BookmarkPlusFill className="rowBtn" size={20} color="#4e33d9" onClick={showAddTemplates} />
                        </label>
                        {showDivAddtemp &&
                            <div className="col-md-5" style={{ position: "absolute", right: "38px" }}>
                                <input ref={txtTempName} className="tableRowInput" style={{ backgroundColor: "whitesmoke", display: "inline-block", width: "70%", borderColor: "#4e33d9" }} />
                                &nbsp;
                                <Button style={{ padding: "0px 2px 0px 2px", fontSize: "13.5px" }} onClick={addNewTemplate}><CheckLg /></Button>
                                &nbsp;
                                <Button variant="danger" style={{ padding: "0px 2px 0px 2px", fontSize: "13.5px" }} onClick={() => setDivAddTemp(false)}><DashCircle /></Button>
                            </div>
                        }
                        {mappedResult && Array.isArray(mappedResult) && mappedResult.map((item, i) =>
                            <div key={i} className="resultTableRow" onClick={e => mapResultClick(e.currentTarget, item.Field)}>
                                {item.ExcelCol}&nbsp;<ArrowLeft style={{ marginTop: "1px" }} color="blue" />&nbsp;{item.Field.DisplayName}
                            </div>)}
                    </div>
                }
                {formName !== "GuaranteeCards" ?
                    <Fragment>
                        <input ref={chkUpdate} type="checkbox" className="form-check-input" />
                        &nbsp;
                        <label style={{ color: "blue" }}>موارد تکراری بروز رسانی شوند</label>
                    </Fragment> :
                    <Row style={{ margin: 0, paddingTop: "10px" }} className="rowBorder">
                        <Col md={3}>
                            <input onChange={e => saveCardData.SaveService = e.target.checked} type="checkbox" className="form-check-input mt-2" />
                            &nbsp;
                            <label style={{ color: "blue" }}>ثبت پذیرش</label> &nbsp;
                            <select className="tableRowInput" onChange={e => saveCardData.ServiceType = e.target.value} style={{ display: "inline-block", maxWidth: "max-content" }}>
                                <option value="">نوع پذیرش</option>
                                <option value="repair">تعمیر</option>
                                <option value="install">نصب</option>
                            </select>
                        </Col>
                        <Col md={4}>
                            <input className="tableRowInput" placeholder="انبار مقصد برای ثبت رسید" onKeyDown={showModalStorage} value={saveCardData.StorageName ?? ""} readOnly />
                            <Button className="btn-input-tiny" style={{ top: "2px" }} onClick={showModalStorage}><List size={18} /></Button>
                        </Col>
                    </Row>
                }
                <div className="mt-1">
                    <Button variant="success" className="group-Btn" onClick={createObjectArray}><CheckLg size={16} />&nbsp;تایــید</Button>
                    <Button variant="danger" className="group-Btn" onClick={close}><DashCircle size={15} />&nbsp;انصراف</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default ModalImportFromExcel;